module.exports = __webpack_public_path__ + "img/dimitar.7c85acc9.webp";